import axios from 'axios';
import authHeader from '@/services/auth-header';

const API_URL = `${process.env.VUE_APP_API_URL}/wts/categories`
const headers = () => ({ headers: authHeader() })

export class CategoryService {
  fetchAll() {
    return axios.get(API_URL, headers() );
  }
  find(id) {
    return axios.get(`${API_URL}/${id}`, headers())
  }
  save(category) {
    const { id } = category;
    if (id) {
      return axios.patch(`${API_URL}/${id}`, { category }, headers());
    }
    else {
      return axios.post(`${API_URL}`, { category }, headers());
    }
  }
}
export default new CategoryService()
